import { FC } from 'react'
import { UseQueryResult } from 'react-query'
import { Draft, PaginatedResponse } from './types/types'
import Card from './Card'
import Pagination from 'backoffice/components/table/Pagination'
import styles from './List.module.scss'
import { Params } from 'api/fetch'

interface ListProps {
  draftsQuery: UseQueryResult<PaginatedResponse<Draft>, unknown>
  setQueryParams: (params: Params | ((prev: Params) => Params)) => void
}

const List: FC<ListProps> = ({ draftsQuery, setQueryParams }) => {
  const { data, isLoading, isError, error } = draftsQuery

  if (isLoading) {
    return <div className={styles.loading}>Loading console petitions...</div>
  }

  if (isError) {
    return (
      <div className={styles.error}>
        Error fetching console petitions: {error instanceof Error ? error.message : 'An unknown error occurred'}
      </div>
    )
  }

  if (!data || data.items.length === 0) {
    return <div className={styles.noResults}>No pending console petitions found.</div>
  }

  return (
    <div>
      <div className={styles.list}>
        {data.items.map((draft) => (
          <Card key={draft.id} draft={draft} />
        ))}
      </div>
      <Pagination
        total={data.total}
        limit={data.limit}
        page={Math.floor(data.offset / data.limit) + 1}
        setQueryParams={setQueryParams}
        isSmallAndUp={true}
      />
    </div>
  )
}

export default List
